<template>
    <div class="header">
        <!-- 消息提示 -->
    <div v-if="currentMessage" class="message-tip"> 
            {{ currentMessage }} 
       </div> 
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage" :collapse="collapse" :default-active="onRoutes">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="refresh-btn" @click="refresh" >
            <i class="el-icon-refresh-right"></i> 
        </div>
        <!--<div class="logo" style="font-size:18px;">{{stationName}}</div>-->
        <div class="header-right">
            <div class="header-user-con">
<!--                <i v-if="gid==11" class="el-icon-hg"></i>-->
<!--                <i v-if="gid==12" class="el-icon-jz"></i>-->
                <!-- 全屏显示 --> 
                 <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank rank"></i>
                    </el-tooltip>
                </div>
                <div class="btn-use" @click="themeSet">
                    <el-tooltip content="系统装修" placement="bottom">
                        <i class="el-icon-brush"></i>
                    </el-tooltip>
                </div> 
                <div class="btn-down" @click="down">
                    <el-tooltip content="下载记录" placement="bottom">
                        <i class="el-icon-download"></i>
                    </el-tooltip>
                </div> 
                <!-- 消息中心 
                <div class="btn-bell">
                    <el-tooltip
                        effect="dark"
                        :content="message?`有${message}条未读消息`:`消息中心`"
                        placement="bottom"
                    >
                        <router-link to="/Message">
                            <i class="el-icon-bell"></i>
                        </router-link>
                    </el-tooltip>
                    <span class="btn-bell-badge"></span>
                </div>  -->
                <!--<el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link"  @click="$router.push('/customer2')">  
                        <i class="el-icon-lx-service rank" ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" > 
                        <el-dropdown-item divided command="Woindex">我的工单</el-dropdown-item> 
                        <el-dropdown-item divided command="WOurl">售后客服</el-dropdown-item> 
                    </el-dropdown-menu>
                </el-dropdown>--> 
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link" style="position: relative;">
                        <span class="user-name-text" style="font-size:18px;margin-left:8px;">{{username}}</span>
                        <div v-if="currentMessage" class="message-tip">{{ currentMessage }}</div>
                        <i style='font-size:18px;' class='el-icon-caret-bottom'></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" > 
                        <el-dropdown-item divided command="memberSet">个人信息</el-dropdown-item>
                        <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
<!--     \

 数据结构
 {
            "id": "37",
            "mid": "43",
            "fileType": ".xlsx",
            "fileLogo": null,
            "loginName": null,
            "phone": null,
            "fileName": "20250509155131.xlsx",
            "fileSize": "4.35KB",
            "status": "1",
            "link": "http://img.yxwl1688.cn/excel/20250509155131.xlsx",
            "delFag": "0",
            "createTime": "2025-05-09 15:51:31",
            "fb1": null,
            "fb2": null
        },  -->
        <!-- 添加文件下载列表组件 -->
        <el-dialog :close-on-click-modal="false" title="下载记录" :visible.sync="downVisible" :modal-append-to-body='false' top="80px" width="680px" :before-close="closeDown">
            <el-table :data="tableData" height="460px" :show-header="false" class="table" style="margin-top:-20px" ref="multipleTable" header-cell-class-name="table-header">
                <el-table-column prop="logo" width="70" align="left" label="文件图标">
                    <template slot-scope="scope">
                        <img style="width:50px;" :src="formatFileIcon(scope.row.fileName)" />
                  </template>
                </el-table-column>

                <el-table-column prop="descript" width="280"    label="文件名称">
                    <template slot-scope="scope">
                        <p style="font-size:14px;line-height:18px;color:#666;">{{scope.row.fileName}}</p>
                        <p>{{scope.row.fileSize}} | <span :style="{ color: scope.row.status === '1' ? '#1b89bc' : scope.row.status === '2' ? '#F56C6C' : '#909399' }">{{ scope.row.status === '0' ? '下载中' : scope.row.status === '1' ? '下载成功' : '下载失败' }}</span></p>
<!--                        <el-progress v-if="scope.row.status == 1"-->
<!--                            :percentage="100"-->
<!--                            :status="success"-->
<!--                        ></el-progress>-->
                        <el-progress v-if="scope.row.status == 2"
                            :percentage="99"
                            :status="exception"
                        ></el-progress>
                        <el-progress v-if="scope.row.status == 0"
                            :percentage="scope.row.progress || 0"
                            :status="warning"
                        ></el-progress>
                    </template>
                </el-table-column>
<!--                <el-table-column prop="status" width="70" align="left" label="状态">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span :style="{ color: scope.row.status === '2' ? '#67C23A' : scope.row.status === '3' ? '#F56C6C' : '#909399' }">-->
<!--                            {{ scope.row.status === '1' ? '下载中' : scope.row.status === '2' ? '下载已完成' : '下载失败' }}-->
<!--                        </span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="createTime"   align="left" label="创建时间"></el-table-column>
                <el-table-column label="操作"   align="right">
                    <template slot-scope="scope">
                        <el-button type="error" @click="handleDel(scope.row)">X</el-button>
                        <el-tooltip :content="!(scope.row.status === '1' || scope.row.link ) ? '当前记录无法下载' : '点击下载'" placement="top" :disabled="scope.row.status === '1'">
                            <el-button 
                                type="error" 
                                @click="downFile(scope.row.link, scope.row.fileName)"
                                :disabled="!(scope.row.status === '1' || scope.row.link ) "
                            >↓</el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-drawer title="系统装修" :visible.sync="colorVisible" direction="rtl" :append-to-body='true'  height="60%">
            <v-content></v-content>
        </el-drawer>
    </div>

</template>
<script>
import bus from '../common/bus';
import vContent from './theme.vue';
import {getData,handDelete} from '../common/header';
import '../../../public/myIcon.css';
import { formatFileIcon } from '@/utils/filters';

export default {
    data() {
        return {
            collapse: false,
            fullscreen: false,
            downVisible:false,
            colorVisible:false,
            message:'1', 
            name: '新用户',    
            tableData:[],
            query:{},
            app:{android:'',apple:''},
            downloadProgress: {},
            sseConnection: null,
            messageQueue: [], // 消息队列
            currentMessage: '', // 当前显示的消息
            messageTimer: null, // 消息定时器
            downloadId: null, // 新增的 downloadId
            progress: 0, // 新增的 progress
            reconnectCount: 0, // 新增重连计数器
            
        };
    }, 

    beforeDestroy() {
    },
    components: { 
        vContent
    },
    created() { 
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });  
    },
    computed: {  
        username() {
            let username = localStorage.getItem(window.location.hostname+'_loginName');
            return username ? username : this.name; 
        },
     
        stationName(){
            let stationName = localStorage.getItem(window.location.hostname+'_stationName');
            return stationName ? stationName : this.stationName;
        },
        onRoutes() {
            return this.$route.path;
        }
    },
    methods: {
        formatFileIcon,
        closeSSE(){
            console.log("检测到弹窗关闭,关闭定时任务")
            // 组件销毁前关闭SSE连接
            if (this.sseConnection) {
                this.sseConnection.close();
            }
            if (this.messageTimer) {
                console.log("检测到弹窗关闭,关闭定时任务")
                clearTimeout(this.messageTimer);
            }
        },
        closeDown(){
            this.downVisible = false;
            this.closeSSE();
        },
        themeSet(){ 
            this.colorVisible = true;
        },
        
        //刷新
        refresh(){
            this.$router.go(0);
        }, 
        down(){
            let data = {};
            data.range = '1';
            data.delFag = '0';
            getData(data).then(res => {
                if (res.code == '200') {
                    // 确保每个数据项都有id字段
                    this.tableData = res.data.map(item => ({
                        ...item,
                        progress: typeof item.progress === 'number' ? item.progress : 0
                    }));
                    console.log('加载的下载记录:', this.tableData);
                    this.downVisible = true;
                    const hasDownloadingFiles = this.tableData.some(item => item.status === '0');
                    if (this.downVisible&&hasDownloadingFiles){
                        this.connectSSE();
                    }
                } else {
                    this.tableData = [];
                }
            });
        },
        handleDel(row){
             handDelete(row).then(res => {  
                if(res.code=='200'){ 
                    this.down();
                    this.$notify({ title: '成功', message: '删除成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '删除失败',duration: 1000, type: 'error' });
                } 
            });
        },
            //文件下载
        downFile(url,name) {
            let fileUrl = url  //服务器文件地址
            this.getBlob(fileUrl).then(blob => {
                this.saveAs(blob, name)
            })
        },
 
        //通过文件下载url拿到对应的blob对象
        getBlob(url) {
            return new Promise(resolve => {
                const xhr = new XMLHttpRequest()
                xhr.open('GET', url, true)
                xhr.responseType = 'blob'
                xhr.onload = () => {
                if (xhr.status === 200) {
                    resolve(xhr.response)
                }
            }
        
            xhr.send()
            })
        },
        //下载文件
        saveAs(blob, filename) {
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
        },
        // 用户名下拉菜单选择事件
        handleCommand(command) { 
            //查询站点app链接  
            if (command == 'loginout') {
                localStorage.removeItem(window.location.hostname+'_loginName');  
                localStorage.removeItem(window.location.hostname+'_phone');  
                localStorage.removeItem(window.location.hostname+'_mid');  
                localStorage.removeItem(window.location.hostname+'_avatar');  
                localStorage.removeItem(window.location.hostname+'_rcode');  
                localStorage.removeItem(window.location.hostname+'_token');  
                localStorage.removeItem(window.location.hostname+'_items');
                localStorage.removeItem(window.location.hostname+'_stationName');
                localStorage.removeItem(window.location.hostname+'_stationLogo');
                this.$router.push('/login');
            }else if(command == 'memberSet'){
                this.$router.push('/memberSet');
            }else if(command == 'Woindex'){
                this.$router.push('/woNav');
            }else if(command == 'WOurl'){
                this.$router.push('/customers'); 
            }else if(command == 'app'){
                window.open(localStorage.getItem('app_android'));
            }else{
                this.$router.push('/index');
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        // 连接SSE
        connectSSE() {
            const baseUrl = process.env.VUE_APP_BASE_URL || '';
            let authorization = localStorage.getItem(window.location.hostname+'_token');
            let userId = localStorage.getItem(window.location.hostname+'_mid');
            const url = `${baseUrl}sse/connect?userId=${userId}&Authorization=${authorization}&pre=excel_down`;
            this.sseConnection = new EventSource(url);

            this.sseConnection.addEventListener('message', (event) => {
                try {
                    console.log("sse接受到消息====>"+event.data);
                    const data = JSON.parse(event.data);
                    if (data.id) {
                        console.log('收到SSE消息===>开始更新进度');
                        console.log('当前tableData:', this.tableData);
                        console.log('要更新的id:', data.id);
                        console.log('要更新的进度:', data.process);
                        
                        // 更新对应文件的进度
                        const fileIndex = this.tableData.findIndex(item => {
                            console.log('比较id:', item.id, data.id, '类型:', typeof item.id, typeof data.id);
                            return String(item.id) === String(data.id);
                        });
                        
                        if (fileIndex !== -1) {
                            console.log('找到对应文件，更新进度:', data.process);
                            // 使用Vue.set确保响应式更新
                            this.$set(this.tableData, fileIndex, {
                                ...this.tableData[fileIndex],
                                progress: Number(data.process)
                            });
                            if (data.process == 100){
                                console.log('找到对应文件，更新状态:', data.process);
                                // 使用Vue.set确保响应式更新
                                this.$set(this.tableData, fileIndex, {
                                    ...this.tableData[fileIndex],
                                    status: "1",
                                    link: data.link,
                                    fileSize: data.fileSize
                                });
                                console.log("当前检测到有推送进度完成-->检测列表中是否还有正在传输的任务")
                                this.closeSSEByTableStatus();
                            }
                            console.log('更新后的数据:', this.tableData[fileIndex]);
                        } else {
                            console.log('未找到对应文件，id:', data.id);
                        }
                    }
                } catch (error) {
                    console.error('SSE message parsing error:', error);
                }
            });

            this.sseConnection.addEventListener('error', (error) => {
                console.error('SSE connection error:', error);
                // 尝试重新连接，但限制重连次数
                if (this.reconnectCount < 5) {
                    this.reconnectCount++;
                    console.log(`尝试第 ${this.reconnectCount} 次重连`);
                   /* this.messageTimer = setTimeout(() => {
                        this.connectSSE();
                    }, 5000);*/
                } else {
                    console.log('SSE连接失败，已达到最大重试次数');
                }
            });
        },
        closeSSEByTableStatus(){
            const hasDownloadingFiles = this.tableData.some(item => item.status === '0');
            if (!hasDownloadingFiles) {
                console.log("没有正在传输的任务，关闭SSE连接");
                this.closeSSE();
            }
        },
        // 处理新消息
        handleNewMessage(data) {
            // 将新消息添加到队列
            this.messageQueue.push(data);
            // 如果当前没有显示消息，立即显示
            if (!this.currentMessage) {
                this.showNextMessage();
            }
        },

        // 显示下一条消息
        showNextMessage() {
            if (this.messageQueue.length > 0) {
                // 从队列中取出第一条消息
                const message = this.messageQueue.shift();
                this.currentMessage = message;
                
                // 5秒后清除当前消息并显示下一条
                this.messageTimer = setTimeout(() => {
                    this.currentMessage = '';
                    this.showNextMessage();
                }, 5000);
            }
        },
        registerProgress(id, percentage) {
            this.downloadId = id;
            this.progress = percentage;
        },
        unregisterProgress() {
            this.downloadId = null;
            this.progress = 0;
        },
        // 处理下载事件
        handleDownload(file) {
            console.log('开始下载文件:', file);
            // 生成唯一的下载ID
            const downloadId = Date.now().toString();
            
            // 更新文件的进度信息
            this.$set(this.tableData, this.tableData.findIndex(item => item.id === file.id), {
                ...file,
                progress: 0
            });

            // 调用下载方法
            this.downFile(file.link, file.fileName);
        },
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }

    }
};
</script>
<style scoped>

.btn-use{ 
    text-align:center;  
    margin-top:5px;
    margin-left:5px;
}
.btn-down{ 
    text-align:center;  
    margin-top:5px;
    margin-left:10px;
}

.header {
    position: relative;
    box-sizing: border-box; 
    width: auto;
    height: 60px;
    font-size: 22px;
    color: #333;
}
.collapse-btn {
    float: left;
    margin-left:15px; 
    cursor: pointer;
    line-height: 60px;   
}
.refresh-btn{
    float: left;
    margin: 0 15px;
    cursor: pointer;
    line-height: 60px;  
}
 
 

 
.header-user-con {
    display: flex;
    height: 60px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 40px;
    height: 40px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
    margin-top:12px;
}
.btn-bell { 
    margin-top:18px;
    margin-right:10px;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #111;
}
.btn-bell .el-icon-bell {
    color: #111;
}
 
.user-avator { 
     width: 30px;
    height: 30px;
    margin-left: 15px;
}
.user-avator img {
    display: block;
    width: 30px;
    height: 30px;
    line-height: 50px;
    border-radius: 50%;
    margin-right:5px;
} 
.el-dropdown-link {
    color: #111;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}

@media screen and (max-width:1000px){
    .rank{
        font-size:20px; 
        margin-top:1px; 
    }
    .user-name {
        margin-left: 5px; 
    }  
    .header{ 
        background:#fff;
        
    }
    .header-right {
        float: right;
        padding-right: 10px;
    }
    .avatar{
        width:25px;height:25px;margin-top:5px;border-radius:50%;vertical-align:middle;
        margin-left:5px;
        margin-right:8px;
    }
   
}
@media screen and (min-width:1000px){
    .rank{
        font-size:25px; 
        margin-top:1px; 
    }
    .avatar{
        width:35px;height:35px;line-height:35px;border-radius:50%;vertical-align:middle;margin:0 5px;
    }
    .user-avator {
    margin:0 10px;
     

}
    .header-right {
    float: right;
    padding-right: 45px;
}
.header .logo {
    float: left;
    width: 250px;
    line-height: 60px; 
    
    
}
}
.message-tip {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%) translateY(32px);
    background: linear-gradient(135deg, #fff 80%, #e3f0ff 100%);
    color: #333;
    padding: 8px 24px;
    border-radius: 10px;
    box-shadow: 0 4px 18px 0 rgba(80,120,200,0.13), 0 1.5px 4px 0 rgba(0,0,0,0.08);
    z-index: 9999;
    font-size: 15px;
    white-space: nowrap;
    pointer-events: none;
    animation: fadeInOut 5s ease-in-out;
    border: 1px solid #e0e6f1;
    letter-spacing: 1px;
    font-weight: 500;
    transition: background 0.3s;
}

@keyframes fadeInOut {
    0% { opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { opacity: 0; }
}
</style> 
